import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-relatedarticleslearnmore-click';

/**
 * User clicks learn more button in related articles section.
 */
export function trackCxFoundationsRelatedarticleslearnmoreClick(
  retailerToken: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, brandToken },
  });
}
